import { combineEpics } from 'redux-observable';

import getWatchListEntriesEpic$ from './getWatchListEntriesEpic';
import createWatchListEntryEpic$ from './createWatchListEntryEpic';
import deleteWatchListEntryEpic$ from './deleteWatchListEntryEpic';


export default combineEpics(
  getWatchListEntriesEpic$,
  createWatchListEntryEpic$,
  deleteWatchListEntryEpic$,
);


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/epics/index.js